import seriesColours from '../seriesColours';

const MAX_WIDTH = 820;

const swatchStyle = (colour) => ({
  border: `1px solid rgb(${colour})`,
  backgroundColor: `rgba(${colour}, 0.2)`,
  color: `rgb(${colour})`,
  // .legend-item's own CSS sizes it 17x17 - htmlLegendPlugin.jsx's ListItem overrides that to 20x20
  // inline, which is also what the checkmark's em-based offset is actually tuned against.
  height: '20px',
  width: '20px',
  minWidth: '20px',
});

// Matches htmlLegendPlugin.jsx's ListItem inline styles exactly - the checkmark's position (in
// .legend-selected::after) is tuned in em units against this specific font-size/layout context.
const itemStyle = {
  alignItems: 'center',
  cursor: 'pointer',
  display: 'flex',
  flexDirection: 'row',
  marginRight: '20px',
  marginBottom: '10px',
  fontSize: '0.925em',
  listStyle: 'none',
};

const labelStyle = {
  margin: 0,
  padding: 0,
  color: '#666',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  maxWidth: '200px',
};

const LegendItem = ({ series, index, label, hidden, onToggle }) => (
  <li className='legend-container-select-box' style={itemStyle} onClick={() => onToggle(series.bucket)}>
    <span
      className={`legend-item ${hidden ? '' : 'legend-selected'}`}
      style={{ ...swatchStyle(seriesColours[index % seriesColours.length]), marginTop: 0 }}
    />
    <p style={labelStyle}>{label}</p>
  </li>
);

// Mirrors htmlLegendPlugin.jsx's MentionsChartLabels: checkbox-style swatches that wrap onto
// additional lines via plain flexWrap once a row is full - no JS width measurement, no overflow
// dropdown. Visibility is plain React state driving which series get passed to the chart, rather
// than imperatively toggling the Chart.js instance.
const BreakdownLegend = ({ breakdown, labelFor, hiddenBuckets, onToggle }) => {
  if (!breakdown?.length) return null;

  return (
    <ul
      className='d-flex align-items-center mb-5 pl-0'
      style={{ maxWidth: MAX_WIDTH, flexWrap: 'wrap' }}
    >
      {breakdown.map((series, index) => (
        <LegendItem
          key={series.bucket}
          series={series}
          index={index}
          label={labelFor(series.bucket)}
          hidden={hiddenBuckets.includes(series.bucket)}
          onToggle={onToggle}
        />
      ))}
    </ul>
  );
};

export default BreakdownLegend;
